import Vue from 'vue';
import ediOrderTransformer from './../../transformers/ediOrder';
import billTransformer from './../../transformers/bill';
import store from './../../store';

const success = (data) => {
  store.dispatch('fetchCurrentBill', billTransformer.fetch(data));
  Vue.router.push({
    name: 'bills.creditNote',
    params: {
      id: data.id,
    },
  });
};

export default (id, ediOrder) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`edi_orders/${id}/credit_note`, ediOrderTransformer.send(ediOrder))
      .then((response) => {
        success(response.data);
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/creditNote.js